import { render, staticRenderFns } from "./NakesAdd.vue?vue&type=template&id=891e51ca&scoped=true"
import script from "./NakesAdd.vue?vue&type=script&lang=js"
export * from "./NakesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891e51ca",
  null
  
)

export default component.exports